import TogglingFilters from './TogglingFilters';

export default TogglingFilters;
